/** 外車事後修改資料（客戶 2026-09-18 決定可改）；只影響之後接的單 */
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Alert, Box, Button, CircularProgress, Paper, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ExtDriverForm from './ExtDriverForm'
import { ExtShell, EXT_MAIN } from './ExtGuard'
import { getExtMe, updateExtMe } from './extService'
import { ExtNotBoundError, extErrorMessage } from './extApiClient'
import type { ExtDriver } from './types'

const ExtProfilePage: React.FC = () => {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const back = params.get('back') || '/ext/me'
  const [me, setMe] = useState<ExtDriver | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [saved, setSaved] = useState(false)

  useEffect(() => {
    getExtMe().then(setMe).catch((err) => {
      if (err instanceof ExtNotBoundError) navigate(`/ext/bind?back=${encodeURIComponent(back)}`, { replace: true })
      else setError(extErrorMessage(err))
    })
  }, [back, navigate])

  const handleSubmit = async (req: Parameters<typeof updateExtMe>[0]) => {
    try {
      const d = await updateExtMe(req)
      setMe(d)
      setSaved(true)
    } catch (err) {
      throw new Error(extErrorMessage(err))
    }
  }

  return (
    <ExtShell>
      <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(back)} sx={{ color: EXT_MAIN, mb: 1 }}>返回</Button>
      <Paper elevation={3} sx={{ p: 3, borderRadius: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: EXT_MAIN, mb: 1 }}>我的資料</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>修改後只影響之後接的單，已接的單車號不變。</Typography>
        {saved && <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSaved(false)}>已更新</Alert>}
        {error ? (
          <Alert severity="error">{error}</Alert>
        ) : !me ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress sx={{ color: EXT_MAIN }} /></Box>
        ) : (
          <ExtDriverForm key={me.id} initial={me} submitLabel="儲存" onSubmit={handleSubmit} />
        )}
      </Paper>
    </ExtShell>
  )
}

export default ExtProfilePage
